export default __webpack_public_path__ + "static/media/CUARZO VERDE.789cfbe8.jpg";